import styled from '@emotion/styled';
import { space } from 'styled-system';
import { StyledProps } from './Content.types';
import { Theme } from '../Box.types';
import css from '@styled-system/css';

export default styled.div<StyledProps, Theme>`
  ${css({
    pb: 8,
    pt: 8,
    '&:last-child': {
      pb: 12,
    },
    '&:first-child': {
      pt: 12,
    },
  })}
  ${space}
`;
